import { render, staticRenderFns } from "./Trail.vue?vue&type=template&id=58abfc85&scoped=true&"
import script from "./Trail.vue?vue&type=script&lang=js&"
export * from "./Trail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58abfc85",
  null
  
)

export default component.exports